import React from 'react';
import { Box, Typography, Paper, Stack } from '@mui/material';
import { IEvent } from '../../types/global/helper';
import { CustomChipGroup } from '../Chip/CustomChipGroup';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

// Type definition for props
interface IEventCell extends Pick<IEvent, 'with_fee' | 'name' | 'kind' | '_id' | 'tags'> {
    onEventClicked?: (id: string) => void;
}

// Reusable Cell Component
const EventCell = ({ _id, kind, name, with_fee, tags, onEventClicked }: IEventCell) => {
    const { themeStyle } = useThemeContext();
    return (
        <Paper
            sx={{ padding: 2, margin: 1, backgroundColor: theme[themeStyle].secondaryBg, cursor: 'pointer' }}
            onClick={() => onEventClicked && onEventClicked(_id)}>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    color: theme[themeStyle].tag_white,
                    fontSize: 12,
                    fontStyle: 'italic',
                }}>
                {kind}
            </Typography>
            <Typography sx={{ fontFamily: FONT_ENUM.REGULAR_HEADER, color: theme[themeStyle].tag_white, fontSize: 18 }}>
                {name}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, marginTop: 1 }}>
                <CustomChipGroup tags={tags} withNiceColor clickable={false} />
            </Box>
        </Paper>
    );
};

// Main Component
export const EventList = ({ events }: { events: IEvent[] }) => {
    return (
        <Stack>
            {events.map(event => (
                <Stack key={event._id}>
                    <EventCell {...event} />
                </Stack>
            ))}
        </Stack>
    );
};
